import Glide from '@glidejs/glide'
import { VE_PAGE_CHANGE } from './custom-events'

export default function slideComponent(props) {
    const {
        identifier,
        perPage,
        perPageDesktop,
        slidesLength,
        withArrows = false,
        loop = false,
        destroySliderOnMobile = false,
        destroySliderOnDesktop = false,
        hideSliderOnMobile = false,
        hideSliderOnDesktop = false,
        glideOptions = {},
    } = props

    return {
        currentSlide: 1,
        glide: null,
        perPage: perPage,
        perPageDesktop: perPageDesktop,

        init() {
            this.setup()
            this.$watch('$store.app.isMobile', (value, oldValue) => (value !== oldValue ? this.setup() : null))
            if (!glideOptions.breakpoints) {
                let resizeTimeout
                window.addEventListener('resize', () => {
                    clearTimeout(resizeTimeout)
                    resizeTimeout = setTimeout(() => {
                        if (this.glide) {
                            this.glide.update({
                                perView: this.getPerViewValue(),
                            })
                        }
                    }, 500)
                })
            }
        },

        getPerViewValue() {
            if (this.$store.app.isMobile) {
                return this.perPage
            } else {
                return this.perPageDesktop
            }
        },

        setup() {
            this.$nextTick(() => {
                this.adjustPerPage()
            })
        },

        setupGlide() {
            const glideElement = this.$el
            if (glideElement) {
                const baseConfig = {
                    type: loop ? 'carousel' : 'slider',
                    perView: this.getPerViewValue(),
                    rewind: loop,
                    autoplay: false,
                    animationDuration: 600,
                    arrows: withArrows,
                    focusedAt: 'center',
                }

                const finalConfig = { ...baseConfig, ...glideOptions }
                this.glide = new Glide(glideElement, finalConfig).mount()

                this.glide.on('run.after', () => {
                    const newSlide = this.glide.index + 1
                    if (this.currentSlide !== newSlide) {
                        this.currentSlide = newSlide
                        this.$dispatch(VE_PAGE_CHANGE, { page: this.currentSlide, identifier })
                    }
                })

                window.addEventListener(VE_PAGE_CHANGE, (event) => {
                    if (event.detail.identifier === identifier && this.currentSlide !== event.detail.page) {
                        this.goToSlide(event.detail.page - 1)
                    }
                })
            }
        },

        adjustPerPage() {
            const shouldDestroy =
                (this.$store.app.isMobile && (destroySliderOnMobile || hideSliderOnMobile)) ||
                (!this.$store.app.isMobile && (destroySliderOnDesktop || hideSliderOnDesktop))

            if (shouldDestroy) {
                this.destroyGlide()
            } else {
                this.reinitializeGlide()
            }
        },

        goToSlide(index) {
            if (this.glide && index >= 0 && index < slidesLength) {
                this.currentSlide = index + 1
                this.glide.go(`=${index}`)
            }
        },

        destroyGlide() {
            if (this.glide) {
                this.glide.destroy()
                this.glide = null
            }
        },

        reinitializeGlide() {
            if (!this.glide) {
                this.setupGlide()
            } else {
                if (glideOptions.breakpoints) return
                this.glide.update({
                    perView: this.getPerViewValue(),
                })
            }
        },
    }
}
